<div [hidden]="!loading" class="spinner-wrap">
	<div class="loading-spinner"></div>
</div>